var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 23,
    fill: "url(#pattern0_6_79)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_79",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_79",
    transform: "matrix(0.046371 0 0 0.0322581 -0.0100806 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_79",
    width: 22,
    height: 31,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAfCAYAAADjuz3zAAAACXBIWXMAAAsTAAALEwEAmpwYAAACvElEQVRIiZXV6W9UZRQG8N9MZypNLZm2UAQtUYIbEIzGBf//D8QlgZC4sAS0LShoy1KqDEzv8OGca9+5zh3aJ5m8mXd57jnP2TrejD6O5drBPoZ4gXHbo86M/XV8gOMtd0Z4gDvYOwzxEr4oCJ/jEf5NsrewjJPoosLN/EAr8Ql8hR628TOetFjcS48+xBzu45qUZ65h6bf54BauCx3bUGEHf+IUVjCf3v1H3MEVLCTpzSlE/XxYmQzayyR/Nz1+ir1eHp4Vmm5PIV3Hebyd/0f4A78WHv2THn6Di3hUW/y5CMqPIpVqfIaP09JnIpDHRPDew8O0mMiMVQzweA6L+AS7DWvXk/QFrubZJn7LD62m6783PDyNqptfJ0UvcD7XH0xmxgg38LcI+KnirOYYdEXACJ1qzAtNn2lPt41cV4q9l6IyF7oOcnm/uFBrX+rdRK1tr7H/Cp1uy4WhSKuByVwvUVtalnNHePuqKyLNZE+oREr1RWCbWBJVV9+rsSjK/HlPaDgWtV/il9w7J/TeSDdXcq8viqmMTc2x0xNR3hapsyLKlGg6V/El1vJXY2x6hZ7J9WFZ0u8InUvXhiJPd0U+74pWeUOUcYmBoh7qgN3HpyK5F00GpEqyB2ajzvu7hND143tp+UdvIJiG42nUEFslsSQeih4wOCLxxVxvpZETxCPRseCS9rHVxGkR+F1F3+g2Lm2KfrqM9w9B2k8j4CdFn24Sj0VfHYsIL5iNC6KNbuGv8mBauQ7zgydFULZaSNeEtkPRActe09oHdkReLwvtHzfO58W06IkB+rRJ0JSiRpUPKpHfS43zy0KCDf8vlJkWEy7uO5jAm0L7dTHy98Qoq45KTEiwKiSZS7KvRSp+b7IBHYmYGEFnRa6uCQluaw/qoYlHadkZEbQnQv+ZOAwxUVUL+fvOwdRpxWswYbPsg9KlUQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.5d80551235a76cb413845b23d061bdfc.svg";
export { ForwardRef as ReactComponent };